import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f770f690&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f770f690')) {
      api.createRecord('f770f690', component.options)
    } else {
      api.reload('f770f690', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f770f690&", function () {
      api.rerender('f770f690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/fourth/index.vue"
export default component.exports